import React, { useState, useEffect, useRef } from "react";
import { BiSolidChevronDown } from "react-icons/bi";
import { Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";

const CustomerSelector = ({
  SelectedCustomer,
  setSelectedCustomer,
  openTrigger = 0,
  onCustomerSelected,
  compact = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [SearchText, setSearchText] = useState("");
  const [GetCustomer, setGetCustomer] = useState(false);
  const triggerRef = useRef(null);
  const searchInputRef = useRef(null);
  const dispatch = useDispatch();
  const Customers = useSelector((state) => state.Customers);

  useEffect(() => {
    setGetCustomer(true);
    dispatch(fetchCustomers());
  }, [dispatch]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "my-popover" : undefined;

  useEffect(() => {
    if (!openTrigger || !triggerRef.current) return;
    setAnchorEl(triggerRef.current);
    setSearchText("");
  }, [openTrigger]);

  useEffect(() => {
    if (!open || !openTrigger) return;
    const timer = setTimeout(() => searchInputRef.current?.focus(), 80);
    return () => clearTimeout(timer);
  }, [open, openTrigger]);

  return (
    <div
      className={`flex flex-col px-0 relative ${compact ? "gap-y-0" : "gap-y-4"}`}
      id="parent"
    >
      <button
        type="button"
        ref={triggerRef}
        aria-haspopup="listbox"
        aria-expanded={open}
        className={`relative w-full text-left cursor-pointer transition-colors ease-in-out duration-200 border border-line hover:border-main bg-card text-ink rounded-lg font-quicksand font-semibold text-sm flex gap-x-3 items-center active:scale-[.99] focus-visible:border-main focus-visible:ring-2 focus-visible:ring-main/15 ${
          compact ? "h-10 px-3" : "px-4 py-3"
        }`}
        onClick={handleClick}
      >
        <div className="flex items-center justify-between w-full">
          <div className="w-full outline-none font-semibold text-sm text-left text-ink bg-transparent">
            {SelectedCustomer === ""
              ? "Select Customer"
              : SelectedCustomer?.name}
          </div>
          <BiSolidChevronDown className="text-xl text-muted shrink-0" />
        </div>
      </button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            width: anchorEl ? anchorEl.offsetWidth : "auto",
            overflow: "hidden",
            marginTop: "6px",
            boxShadow:
              "0 4px 12px rgba(16,69,70,0.08), 0 12px 28px rgba(16,69,70,0.08)",
            border: "1px solid #E5E9EB",
            maxHeight: "50vh",
          },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className="bg-card text-ink font-quicksand p-2 flex flex-col">
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search customer"
            aria-label="Search customer"
            className="w-full px-3 py-2 rounded-lg border border-line bg-card text-ink placeholder:text-muted text-sm outline-none focus:border-main focus:ring-2 focus:ring-main/15 mb-2"
            value={SearchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <div className="flex flex-col gap-y-0.5 max-h-[40vh] overflow-y-auto scrollable">
            {Customers.data &&
              Customers.data
                .filter((customer) =>
                  SearchText === ""
                    ? true
                    : customer.name
                        .toLowerCase()
                        .includes(SearchText.toLowerCase())
                )
                .map((customer) => {
                  const active = SelectedCustomer?._id === customer._id;
                  return (
                    <button
                      type="button"
                      key={customer._id}
                      className={`flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm font-semibold transition-colors ${
                        active
                          ? "bg-brandSoft text-main"
                          : "text-inkSecondary hover:bg-subtle"
                      }`}
                      onClick={() => {
                        setSelectedCustomer(customer);
                        handleClose();
                        onCustomerSelected?.(customer);
                      }}
                    >
                      <span
                        className={`h-4 w-4 shrink-0 rounded-full border-2 ${
                          active
                            ? "border-main bg-main"
                            : "border-line bg-card"
                        }`}
                      />
                      <span className="truncate">{customer.name}</span>
                    </button>
                  );
                })}
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default CustomerSelector;
